import { Outlet, useLocation, useNavigate } from "react-router-dom";
import SideNav from "../../../components/side-nav/side-nav";
import Header from "../../../components/header/header";
import { useEffect, useState } from "react";

export default function SiteLayout() {
    const location = useLocation();
    const navigate = useNavigate();
    const [showResponsiveMenu, setShowResponsiveMenu] = useState<boolean>(false);

    useEffect(() => {
        if (location.pathname === '/') {
            navigate('/dashboard');
        }
    }, [location.pathname, navigate]);

    return (
        <section className="main-container">
            <SideNav 
                showResponsiveMenu={showResponsiveMenu}
                closeResponsiveMenu={() => setShowResponsiveMenu(false)}
            />
            <main>
                <Header 
                    toggleResponsiveMenu={() => {
                        setShowResponsiveMenu(!showResponsiveMenu);
                    }}
                />
                <Outlet />
            </main>
        </section>
    );
}